module.exports = __webpack_public_path__ + "img/closed_incubator.cf8ba79f.png";